module.exports = __webpack_public_path__ + "img/信阳市.bbf2c323.png";